
const companyRouter = [
    // 公司首页
    {path: '/companyHome', name: 'companyHome', component: () => import('@/views/company/home')},
    // 公司产品页
    {path: '/companyProduct', name: 'companyProduct', component: () => import('@/views/company/product')},
    // 公司图搜搜首页
    {path: '/conpanyImgsearchIndex', name: 'conpanyImgsearchIndex', component: () => import('@/views/company/index')},
    // 公司图搜搜列表页
    {path: '/companyImgsearchList', name: 'companyImgsearchList', component: () => import('@/views/company/list')},
    // 公司联系我们页面
    {path: '/companyContact', name: 'companyContact', component: () => import('@/views/company/contact')},
]
export default companyRouter


// WEBPACK FOOTER //
// ./src/router/modules/company.js